import { TrainOfferDateSelectorType, TrainOfferDateSelector, TrainListChangeType, TrainSelectionType, TicketRadioType, PassengerSetType, TrainOfferRequest, ShuttleOfferRequest } from "../../../../Orchestrator/Types/Index";
import { PriceInfo, TrainType } from "../../../../Orchestrator/Types/Types/TrainTypes";



export class SelectOfferContext {

    public routeTo: string[] = [];
    public trainOfferDateSelectorType!: TrainOfferDateSelectorType;
    public trainOfferDateSelector!: TrainOfferDateSelector;
    public filterValue: string[] = [];
    public trainListChangeType!: TrainListChangeType;
    public visibleTrains: number = 0;
    public standardPriceInfo!: PriceInfo;
    public premiumPriceInfo!: PriceInfo;
    public trainSelectionType!: TrainSelectionType;
    public ticketType!: string;
    public ticketRadioType!: TicketRadioType;
    public passengerSetType!: PassengerSetType;
    public trainOfferRequest!: TrainOfferRequest;
    public shuttleOfferRequest!: ShuttleOfferRequest;
    public filteredTrains!: TrainType[];
    public nextTo: string[] = [];
    public isAnonymous: boolean = false;

    constructor() {

    }
}